import _isEmpty from 'lodash/isEmpty';

export function getNewTeamMemberOrder(teamMembers = []) {
  if (_isEmpty(teamMembers)) {
    return 0;
  }
  return Math.max(teamMembers.length, ...teamMembers.map(({ order }) => order + 1));
}
